// Copyright 2022, University of Colorado Boulder

/**
 * Export a sort direction enum.
 *
 * @author Liam Mulhall <liammulh@gmail.com>
 */

const SortDirectionEnum = {
  ASCENDING: 'ascending',
  DESCENDING: 'descending'
};

Object.freeze( SortDirectionEnum );

export default SortDirectionEnum;